import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { BASENAME_URL_OPPORTUNITIES, BASENAME_URL_PROCESSES, BASENAME_URL_USER } from 'constants/settings';
import { SIDEBAR_BUTTONS, SIDEBAR_BUTTONS_CONFIG } from 'constants/sidebar';

import { containString } from 'services/util/auxiliaryUtils';

import type { TSidebarStore } from 'types/store/sidebar';
import type { Nullable } from 'types/utils';

export const useSidebarStore = create<TSidebarStore>()(
    devtools((set, get) => ({
        buttonSelected: null,
        sidebarOpen: false,
        sidebarState: null,
        isSidebarPermanent: true,
        showErrorDevice: null,
        sectionSelected: null,
        languageSelectorDialogOpen: false,
        actions: {
            setButtonSelected: (value) => set({ buttonSelected: value }),

            setSidebarOpen: (value) => set({ sidebarOpen: value }),

            setShowErrorDevice: (value) => set({ showErrorDevice: value }),

            setSectionSelected: (value) => set({ sectionSelected: value }),

            setLanguageSelectorDialogOpen: (value) => set({ languageSelectorDialogOpen: value }),

            setSidebarState: (value) => set({ sidebarState: value }),

            handleLocationChange: (locationPathname: string, isMobileScreen: boolean, matches: boolean) => {
                const currentState = get();
                const _isPermanent = isMobileScreen ? false : true;

                // Initialize sidebarOpen based on screen size
                if (matches && !currentState.sidebarOpen) {
                    set({ sidebarOpen: true });
                }

                // Handle location-based sidebar state
                let buttonSelected: Nullable<string> = null;
                switch (locationPathname) {
                    case BASENAME_URL_USER:
                        buttonSelected = null;
                        break;
                    case BASENAME_URL_OPPORTUNITIES:
                        buttonSelected = SIDEBAR_BUTTONS.OPPORTUNITIES;
                        break;
                    case BASENAME_URL_PROCESSES:
                        buttonSelected = SIDEBAR_BUTTONS.PROCESSES;
                        break;
                    default:
                        break;
                }

                set({
                    buttonSelected,
                    isSidebarPermanent: _isPermanent,
                });

                if (!containString(['site-survey', 'proposals', 'om'], locationPathname)) {
                    set({ sectionSelected: null });
                }

                if (_isPermanent) {
                    set({
                        sidebarOpen: currentState.sidebarState ?? currentState.sidebarOpen,
                        sidebarState: null,
                    });
                } else {
                    set({
                        sidebarState: currentState.sidebarOpen,
                        sidebarOpen: false,
                    });
                }
            },
        },
    }))
);

// Computed value for sidebarConfig (memoized constant)
export const getSidebarConfig = () => SIDEBAR_BUTTONS_CONFIG.DEFAULT;
